// extracted by mini-css-extract-plugin
module.exports = {"templateName":"TemplateName_templateName__2o9ja","serviceName":"TemplateName_serviceName__3gDWW","icon":"TemplateName_icon__2zCAj"};